export const rolesKeys = {
  frontEnd: "frontEnd",
  fullStack: "fullStack",
  backEnd: "backEnd",
};

const desiredRoles = {
  [rolesKeys.frontEnd]: "Front-end developer",
  [rolesKeys.fullStack]: "Full-stack developer",
  [rolesKeys.backEnd]: "Back-end developer",
};

const titleTechStack = {
  [rolesKeys.frontEnd]: "React",
  [rolesKeys.fullStack]: "React, Node.js",
  [rolesKeys.backEnd]: "Node.js, AWS",
};

const firstName = "Alexander";
const lastName = "Piskun";

export const titleFullname = `${firstName} ${lastName}`;
const fileFullName = `${firstName}_${lastName}`;
const fileExtension = "pdf";

const fileName = {
  [rolesKeys.frontEnd]: `FE-React-${fileFullName}.${fileExtension}`,
  [rolesKeys.fullStack]: `FS-React_Nodejs-${fileFullName}.${fileExtension}`,
  [rolesKeys.backEnd]: `BE-Nodejs-${fileFullName}.${fileExtension}`,
};

export const getFileName = (desiredRole) => fileName[desiredRole];
export const getDesiredRoleTitle = (desiredRole) => desiredRoles[desiredRole];
export const getDesiredRoleTitleTeckStack = (desiredRole) =>
  titleTechStack[desiredRole];
